
import { defineComponent } from "vue";
import { usePlugin } from "@/plugins";

export default defineComponent({
  name: "CancelButton",
  emits: ["complete"],
  setup(_, { emit }) {
    const { confirmation } = usePlugin();

    const onComplete = () => {
      confirmation.require({
        header: "สิ้นสุดการทำงาน",
        message: "กรุณายืนยันเพื่อสิ้นสุดการทำงาน?",
        acceptLabel: "ยืนยัน สิ้นสุดการทำงาน",
        rejectLabel: "ปิด",
        acceptClass: "p-button-success",
        accept: () => {
          emit("complete");
        },
      });
    };
    return { onComplete };
  },
});
